import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { InvestmentsService } from '../investments.service';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { AutenticationEventType } from '../../../autentication/autentication.event.type';
import { Investment } from '../investments-extract/models/investment';
import { Router } from '@angular/router';
import { Auth } from '../../../autentication/Auth';

@Component({
	selector: 'app-redeem-balance',
	templateUrl: './redeem-balance.component.html',
	styleUrls: ['./redeem-balance.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RedeemBalanceComponent implements OnInit {

	public investments: Array<Investment> = [];
	public investment: Investment = new Investment();

	constructor(
		private investmentsService: InvestmentsService,
		private router: Router
		) { }

	ngOnInit() {
		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.load();
		});
		this.load();
	}

	getRouteInvestmentId(data) {
		this.preload(true);

		this.investmentsService.getInvestment(data.id).subscribe( investment => {
			this.investment = investment;
			this.preload(false);
		});
	}

	load() {
		this.preload(true);

		this.investmentsService.getMyInvestments('2008-01-01', new Date()).subscribe( data => {
			this.investments = data;
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.preload(false);
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="redeem-balance"] .content', show: active, delay: delay});
	}

	sendForm(event, investmentNumber) {
		this.router.navigate(['investimentos/resgatar-saldo/resgate/' + investmentNumber]);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/redeem-balance/redeem-balance.component.ts